export default function isValidPassword(password) {
  let missing = [];

  if (!/[A-Z]/.test(password)) missing.push("mayúscula (A-Z)");
  if (!/[a-z]/.test(password)) missing.push("minúscula (a-z)");
  if (!/[0-9]/.test(password)) missing.push("número (0-9)");
  if (!/[!@#$%^&*()\-_+=\[\]{};:'",.<>?/\\|`~]/.test(password)) 
    missing.push("símbolo (!@#$...)");

  if (missing.length === 0) {
    return { success: true, message: "Contraseña válida ✅" };
  } else {
    return { success: false, message: "Se esperaba " + missing.join(", ") };
  }
}